import React__default from 'react';
import { Tooltip } from '@deal/components';
import { useApplicationContext, Application } from '../../../../containers/ApplicationContext/index.js';
import MessageBubble from '../../../MessageBubble/index.js';
import { BusinessRichCardEvents } from '../../../../containers/RichCardEventEmitter/BusinessEventData/index.js';
import { useRichCardEventEmitter } from '../../../../containers/RichCardEventEmitter/index.js';
import CallToAction from '../../components/CallToAction/index.js';
import styles from './styles.css.js';
import { useProductQuizBusinessLeadQuery } from './ProductQuizBusinessLead.generated.js';

var ProductQuiz = function ProductQuiz(_a) {
  var message = _a.message,
      richCard = _a.richCard;
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;
  var leadId = richCard.leadId;
  var data = useProductQuizBusinessLeadQuery({
    variables: {
      leadId: leadId
    }
  }).data;
  return (data === null || data === void 0 ? void 0 : data.lead) ? React__default.createElement("div", {
    className: styles.messages
  }, React__default.createElement(MessageBubble, {
    message: message
  }, React__default.createElement("div", {
    className: styles.message
  }, React__default.createElement(Tooltip, {
    placement: "top",
    message: "The user sees a quiz asking them to like / dislike products. The products shown are\n                based on the answers to their quiz. You can see their ratings in the \"Items Rated\"\n                section."
  }), React__default.createElement("div", {
    className: styles.title
  }, "Product rating in progress"), React__default.createElement("div", {
    className: styles.text
  }, data.lead.consumer.firstName, " is in the process of rating products. View his/her resposes as they come in by clicking the button below.")), application === Application.BUSINESS ? React__default.createElement(CallToAction, {
    onClick: function onClick() {
      return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
        type: BusinessRichCardEvents.OPEN_RATED_ITEMS_PANEL
      });
    }
  }, "View Survey results") : React__default.createElement(CallToAction, {
    onClick: function onClick() {
      return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
        type: BusinessRichCardEvents.OPEN_RATED_ITEMS_PANEL
      });
    }
  }, "View Survey results"))) : null;
};

export default ProductQuiz;
//# sourceMappingURL=index.js.map
